<template>
  <div class="index">
    <van-nav-bar
        title="气价公示"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />

    <div class="van-doc-demo-block__card">
      <van-panel title="气价公示" desc="江山市物价局关于核定江山市区居民生活用管道天然气销售价格的通知" >
        <div class="doc_title">
          <van-swipe class="my-swipe" :autoplay="4000" indicator-color="white">
            <van-swipe-item>
              <van-image fit="cover" :src="require('./../assets/img/qjgs1.png')" />
            </van-swipe-item>
            <van-swipe-item>
              <van-image fit="cover" :src="require('./../assets/img/qjgs2.png')" />
            </van-swipe-item>
            <van-swipe-item>
              <van-image fit="cover" :src="require('./../assets/img/qjgs3.png')" />
            </van-swipe-item>
          </van-swipe>
        </div>
      </van-panel>
    </div>



  </div>
</template>
<script>
export default {
  name: 'page_bind',
  data() {
    return {

    };
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1);
    }

  },
  mounted () {

  }
}
</script>
<style>
.index{
  height: 100vh;
  background-color: #f5f5f5;
}
.doc-demo-block__card {
  margin: 16px 12px 0px;
  overflow: hidden;
  border-radius: 8px;
}
.doc_title {
  margin: 0;
  padding: 22px 16px 0px 16px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
</style>